
export default class Log {
  constructor(name, util) {
    // コンストラクタ
    this.ModuleName = name;
  }

  // オペレーションログ
  info(s) {
    this.log(s);
  }

  log( s ){
    console.log( `[${this.ModuleName}] - ${s}` );
  }

  // デバッグログ ※開発環境のみ出力
  debug(s) {

    if ( this.isDebug() == true ){
      this.log(s);
    }
  }
  isDebug(){
    return ( process.env.GATSBY_ENV == 'development');
  }

  // デバッグ：オブジェクトログ ※開発環境のみ出力
  alog(s, obj) {
    if ( this.isDebug() == true ){
      this.log(s);
      console.dir(obj);
    }
  }

  // エラーログ出力
  error(s) {
    console.error( `[${this.ModuleName}] - ${s}` );
  }
}
